"use client";

import { useEffect } from "react";
import { isLocalDevHost } from "@/lib/isLocalDevHost";

export default function GTMOnInteraction2() {
  useEffect(() => {
    // Keep local dev sessions out of the production analytics / Clarity projects
    if (isLocalDevHost()) return;

    const loadGTM = () => {
      if (window.gtmScript2Loaded) return;
      window.gtmScript2Loaded = true;
      const script = document.createElement("script");
      script.id = "gtm-script-2";
      // crossOrigin: see GTMOnInteraction (unmasks gtm.js errors in Clarity)
      script.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
                        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
                        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.crossOrigin='anonymous';j.src=
                        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
                        })(window,document,'script','dataLayer','GTM-KPRBJW53');`;
      document.head.appendChild(script);
    };

    // Same idle-load rationale as GTMOnInteraction: keep the second GTM
    // container off the critical load path and off the interaction path.
    let idleId: number | undefined;
    let timerId: ReturnType<typeof setTimeout> | undefined;
    if (typeof window.requestIdleCallback === "function") {
      idleId = window.requestIdleCallback(loadGTM, { timeout: 3500 });
    } else {
      timerId = setTimeout(loadGTM, 3000);
    }

    return () => {
      if (idleId !== undefined) window.cancelIdleCallback?.(idleId);
      if (timerId) clearTimeout(timerId);
    };
  }, []);

  return null;
}
